import React from "react";
import Ingredient from "../Ingredient";
import raw from "../../assets/images/ingredients/Chicken_Breast.png";
import cooked from "../../assets/images/ingredients/Cooked_chicken.png";

const Chicken = ({ onClick, changeable=true, changed, hideable=true }) => {
    return (
        <Ingredient
            name="Chicken"
            image={[raw, cooked]}
            changeable={changeable}
            changed={changed}
            hideable={hideable}
            onClick={onClick}
        />
    );
};

export default Chicken;